<div class="sk-m-singleImg-wap"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
            <div class="mainBox">
               {{if style.isShowTitle == '1'}}
                    <% include('../common/title.art', {title: basic.title, terminal: 'title-wap'}) %>
               {{/if}}
                <div>
                {{if content.linkType != 'none' && !isDesign}}
                   <a target="_blank" href="{{content.linkType == 'none'?'javascript:void(0)':content.link}}">
                 {{/if}}
                   <img src="{{content.imgUrl}}" alt="" width="100%">
                   {{if content.linkType != 'none' && !isDesign}}
                   </a>
                   {{/if}}
                </div>
            </div>
        </div>